import './Home.scss'
import img from './info.jpeg'

interface HomeProps {
	lang: String
}

const Home: React.FC<HomeProps> = (props: HomeProps) => {
	if (props.lang === 'nl') {
		return (<div className="row home">
			<h1>Na het succes van afgelopen jaren zal de 4e editie van 'Women at the Top' plaats vinden op dinsdag 26 mei 2026</h1>
			<img src={img} className='col-md-6 order-md-last' alt='' />
			<div className='col-md-6'>
				<p>
					Het is voor ons als vrouwelijke studentes een stuk minder vanzelfsprekend om door te groeien binnen een bedrijf naar een topfunctie. Dit komt vooral doordat er maar weinig voorbeelden zijn in studentes hun directe omgeving van vrouwen in de top. Niemand die kan laten zien dat het ook normaal is voor een vrouw om zelfverzekerd en met veel passie voor je werk hogerop te komen binnen een bedrijf of organisatie. Oftewel, tijd voor verandering! <br></br>
					Het evenement 'Women at the Top' is een inspirerende bijeenkomst die zich richt op het bevorderen van gendergelijkheid en het aanmoedigen van vrouwen om leidinggevende posities te bereiken. Het doel van dit evenement is om de barrières te doorbreken die vrouwen vaak tegenkomen bij het nastreven van topfuncties in verschillende sectoren. Daarnaast fungeert het evenement ook als een platform voor het opbouwen van waardevolle netwerken. Studentes hebben de kans om contact te leggen met invloedrijke figuren in hun vakgebied en onderlinge ondersteuning te bieden. Het is een krachtig evenement dat vrouwen inspireert om hun volledige potentieel te benutten en een blijvende impact te hebben op hun respectievelijke industrieën.
				</p>
			</div>
		</div>

		)
	} else {
		return (
			<div className="row home">

				<h1>After the success of recent years, the 4th edition of 'Women at the Top' will take place on Tuesday, May 26th, 2026</h1>
				<img src={img} className='col-md-6 order-md-last' alt='' />
				<div className='col-md-6'>
					<p>
						As female students, it's much less common for us to advance within a company to a top position. This is mainly because there are few examples in their immediate environment of women in top positions. No one who can show that it is also normal for a woman to confidently and passionately advance in her work within a company or organization. In other words, time for change! <br></br>
						The 'Women at the Top' event is an inspiring gathering aimed at promoting gender equality and encouraging women to achieve leadership positions. The goal of this event is to break down the barriers that women often encounter when pursuing top positions in various sectors. Additionally, the event also serves as a platform for building valuable networks. Students have the opportunity to connect with influential figures in their field and provide mutual support. It is a powerful event that inspires women to fulfill their full potential and have a lasting impact on their respective industries.
					</p>
				</div>
			</div>
		)
	}
}
export default Home